import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
const Wrapper = styled.div `
  display: flex;
`;
export const IconUser = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            const head = wrapperRef.current?.querySelector('svg path:first-child');
            if (head) {
                gsap.to(head, {
                    keyframes: [
                        {
                            rotate: '-15deg',
                            duration: 0.075,
                        },
                        {
                            rotate: '15deg',
                            duration: 0.15,
                        },
                        {
                            rotate: '0deg',
                            duration: 0.25,
                            onComplete: () => {
                                triggerDone();
                            },
                        },
                    ],
                });
            }
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Icon.User, null)));
};
//# sourceMappingURL=User.js.map